<section class="w-full h-full md:px-10 md:py-24 px-4 py-8">
  <div class="container mx-auto h-full w-full">
    <div class="flex flex-col items-center justify-center gap-4">
      <h2
        i18n="organizations|Our organizations heading@@organizations.title"
        class="md:text-3xl text-2xl font-bold text-black"
      >
        Our Organizations
      </h2>
    </div>
    <div class="flex flex-row flex-wrap items-center justify-center md:gap-10 gap-4 mt-10">
      @for (organization of organizations; track $index) {
        <div
          class="w-20 h-20 md:w-40 md:h-40 bg-gray-200 rounded-2xl md:rounded-4xl overflow-hidden"
        >
          <div class="w-full h-fit bg-gray-200"></div>
        </div>
      }
    </div>
  </div>
</section>
